<ng-template #template>
    <div class="flex flex-col gap-5 p-10 text-lg dynamic-dialog-container">

        <ng-content select="[title]"></ng-content>

        <ng-content></ng-content>

        <!-- Actions -->
        <div *ngIf="showActions" class="w-full flex justify-between items-center">
            <!-- Cancel -->
            <span>
                <ng-content select="[cancel-button]"></ng-content>
                <!-- Default cancel button if no cancel-button is found -->
                <button mat-button class="default text-app-global-tertiary" [mat-dialog-close]="false"
                    i18n>Annuleren</button>
            </span>

            <!-- Confirm -->
            <span>
                <ng-content select="[confirm-button]"></ng-content>
                <!-- Default cancel button if no confirm-button is found -->
                <button mat-flat-button color="secondary" class="default" [mat-dialog-close]="true"
                    i18n>Bevestigen</button>
            </span>
        </div>
    </div>
</ng-template>